var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 70,
    viewBox: "0 0 86 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9542 41.7323L55.1932 29.4136L64.4322 43.2721V38.6526H76.7509V17.0949C76.7509 13.698 73.9884 10.9355 70.5916 10.9355H30.5558C27.159 10.9355 24.3965 13.698 24.3965 17.0949V54.051C24.3965 57.4478 27.159 60.2103 30.5558 60.2103H55.1932V47.8916H33.6355L42.8745 35.5729L45.9542 41.7323Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5577 30.7967L30.7967 18.478L40.0357 32.3366V27.717H52.3544V6.15934C52.3544 2.76247 49.592 0 46.1951 0H6.15934C2.76247 0 0 2.76247 0 6.15934V43.1154C0 46.5123 2.76247 49.2748 6.15934 49.2748H30.7967V36.9561H9.23902L18.478 24.6374L21.5577 30.7967Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7509 44.8105H70.5916V54.0496H61.3525V60.2089H70.5916V69.4479H76.7509V60.2089H85.9899V54.0496H76.7509V44.8105Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/uploadImage.ffda14273c43db7ec3f12b639ce70bd4.svg";
export { ForwardRef as ReactComponent };